import { Container } from "reactstrap";
import BreadCrumb from "../../components/Common/BreadCrumb";
import { SkeletonTheme } from "react-loading-skeleton";
import SmsLog from "../SmsLogs";
import { useTranslation } from "react-i18next";

const SmsHistory = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("smsLogs.historyTitle") });
  return (
    <>
      <SkeletonTheme baseColor="#F0F4F6" highlightColor="#e9ebec">
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title={t("smsLogs.historyTitle")} hideCrumbs={true} />
            <SmsLog />
          </Container>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default SmsHistory;
